import React from "react";
import { Route, Redirect } from "react-router-dom";
import {history,routes,renderRoutes} from '@/router';
import cookie from "react-cookies";
import {isUserLogin} from '@/utils/user';
import {isAuthorLogin} from '@/utils/author';

class FrontendAuth extends React.Component {
  render() {
    const pathname = this.props.location.pathname;
    const targetRouter = routes.find(function(item) {
      if (item.path.indexOf(":") != -1)
      {
        if(pathname.indexOf(item.path.split(":")[0]) != -1)
        {
          return true;
        }
        return false;
      }
      else
        return item.path === pathname;
    });

    /* if (pathname === "/") {
      return <Redirect to="login"></Redirect>;
    }

    if (!targetRouter) {
      return <Redirect to="404" />;
    }*/

    if (pathname.indexOf('/author') !== -1)
    {
      if (!isAuthorLogin()) {
        if (pathname !== '/author/login')
          location.href = '/author/login'
      }
    }

    if (isUserLogin()) {
      return (
        renderRoutes(routes)
      );
    } else {
      if (targetRouter.auth) {
        return <Redirect exact to="/" />;
      } else {
        return (
          renderRoutes(routes)
        );
      }
    }
  }
}

export default FrontendAuth;
